import React from "react";
import "./ActionButton.scss";

const ActionButton = (props) => {
  return (
    <button
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      onClick={props.onClick}
      className={`map-btn ${props.icon} ${
        props.pushed ? "map-btn-pushed" : ""
      } ${props.className ?? ""}`.trim()}
      title={props.title}
      disabled={props.disabled}
    />
  );
};

export default ActionButton;
